export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/dragging-icon.svg?01b80fe8718a374509a39e2116e31e8d";